import React from 'react';
import Manage from './Manage';
import { ChannelPartnersProvider } from '../../../contexts/ChannelPartnerContext';


const ChannelPartnersPage = () => {
    return (
        <ChannelPartnersProvider>
            <Manage />
        </ChannelPartnersProvider>
    );
};

export default ChannelPartnersPage;
